<!--
 * @message: 内容区域标题部分（包含右侧工具栏）
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-06-30 17:36:38
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_ContentNav.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-18 13:21:44
 -->
<template>
  <v-app-bar class="transparent mb-6 pa-0" elevation="0" dense v-if="!hidden">
    <v-toolbar-title class="d-flex align-center fill-height ml-n4">
      <span class="text-h3">{{ title }}</span>
      <v-sheet class="transparent fill-height d-flex align-center">
        <slot name="appendTitle" />
      </v-sheet>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <div class="fill-height d-flex justify-end flex-nowrap align-center mr-n4">
      <slot name="nav-actions" />
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            class="primary mr-4"
            color="white"
            v-on="on"
            width="40"
            height="40"
            v-show="exportBtn"
            @click.stop="
              $confirmWarn(
                $t('label_essweb_RosterRecord_list_exportOutBtnLabel'),
                $t('message_essweb_system_operation_export_outLabel'),
                null,
                $t('message_essweb_system_operation_export_exportOutLabel')
              ).then((res) => {
                if (res) onTriger('export');
              })
            "
          >
            <svg-icon size="24" iconClass="export" />
          </v-btn>
        </template>
        <span>{{
          $t("message_essweb_system_operation_export_exportOutLabel")
        }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            class="primary mr-4"
            color="white"
            v-on="on"
            width="40"
            height="40"
            v-show="importBtn"
            @click.stop="onTriger('import')"
          >
            <svg-icon size="24" iconClass="import" />
          </v-btn>
        </template>
        <span>{{
          $t("message_essweb_system_operation_export_exportInLabel")
        }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            class="primary mr-4"
            color="white"
            v-on="on"
            width="40"
            height="40"
            v-show="delBtn"
            @click.stop="onTriger('delete')"
          >
            <span class="material-icons-round">delete</span>
          </v-btn>
        </template>
        <span>{{ $t("message_essweb_list_components_tools_delBtnTip") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            class="primary mr-4"
            color="white"
            v-on="on"
            width="40"
            height="40"
            v-show="editBtn"
            @click.stop="onTriger('edit')"
          >
            <span class="material-icons-round">edit</span>
          </v-btn>
        </template>
        <span>{{ $t("message_essweb_list_components_tools_editBtnTip") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            class="primary mr-4"
            color="white"
            v-on="on"
            width="40"
            height="40"
            v-show="addBtn"
            @click.stop="onTriger('new')"
          >
            <v-icon>add</v-icon>
            <!-- <span class="material-icons-round">add</span> -->
          </v-btn>
        </template>
        <span>{{ $t("message_essweb_list_components_tools_newBtnTip") }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            class="primary mr-4"
            color="white"
            v-on="on"
            width="40"
            height="40"
            v-show="saveBtn"
            @click.stop="onTriger('save')"
          >
            <span class="material-icons-round">save_alt</span>
          </v-btn>
        </template>
        <span>{{ $t("message_essweb_list_components_tools_saveBtnTip") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            class="primary mr-4"
            color="white"
            v-on="on"
            width="40"
            height="40"
            v-show="manageBtn"
            @click.stop="onTriger('manage')"
          >
            <span class="material-icons-round">ballot</span>
          </v-btn>
        </template>
        <span>{{
          $t("message_essweb_list_components_tools_mangeBtnTip")
        }}</span>
      </v-tooltip>
    </div>
  </v-app-bar>
</template>
<script>
export default {
  name: "ContentNav",
  props: {
    hidden: { default: false, type: [Boolean, Number] },
    title: { defaule: "", type: String },
    addBtn: { default: false, type: [Boolean, Number] },
    saveBtn: { default: false, type: [Boolean, Number] },
    manageBtn: { default: false, type: [Boolean, Number] },
    delBtn: { default: false, type: [Boolean, Number] },
    editBtn: { default: false, type: [Boolean, Number] },
    exportBtn: { default: false, type: [Boolean, Number] },
    importBtn: { default: false, type: [Boolean, Number] },
  },
  watch: {},
  data() {
    return {};
  },
  methods: {
    onTriger: function (action) {
      const that = this;

      // if (action == "delete") {
      //   //拦截删除
      //   const confirm = this.$confirm({
      //     text: "是否删除?",
      //     title: "警告",
      //     button: [
      //       {
      //         text: "Cancel",
      //         show: true,
      //         ontap: function() {
      //           confirm.close();
      //         },
      //       },
      //       {
      //         text: "Ok",
      //         show: true,
      //         ontap: function() {
      //           confirm.close().then(function(res) {
      //             that.$emit("triger", "delete");
      //           });
      //         },
      //       },
      //     ],
      //   });
      // } else {
      this.$emit("triger", action);
      // }
    },
  },
};
</script>
